import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Alert, AlertType } from 'src/interface/alert';

@Injectable({
  providedIn: 'root'
})

export class AlertService {

  private subject = new Subject<Alert>();
  private defaultId = 0;

  // enable subscribing to alerts observable
  onAlert(): Observable<Alert> {
    return this.subject.asObservable();
  }

  //For success alert.
  success(message: string, options?: Partial<Alert>) {
    this.alert(new Alert({ ...options, type: AlertType.Success, title:'common.success', message }));
  }

  //For error alert.
  error(message: string, options?: Partial<Alert>) {
    this.alert(new Alert({ ...options, type: AlertType.Error, title:'common.error', message }));
  }

  //For information alert.
  info(message: string, options?: Partial<Alert>) {
      this.alert(new Alert({ ...options, type: AlertType.Info, title:'common.info', message }));
  }

  //For warning alert.
  warn(message: string, options?: Partial<Alert>) {
      this.alert(new Alert({ ...options, type: AlertType.Warning, title:'common.warning', message }));
  }

  //main alert method    
  alert(alert: Alert) {
     alert.id = Math.random();
     this.subject.next(alert);
  }

  // // clear alerts
  // clear(id = this.defaultId) {
  //     this.subject.next(new Alert({ id }));
  // }
}
